// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Here OAuth tokens/JWTs are needed:
  allowedResourceServerUrls: [
    'http://localhost:8081', // SCSN service
    'http://localhost:8082', // Customer Service
    'http://localhost:8083', // Products Service
    'http://localhost:8084', // Orders Service
    'http://localhost:8085', // Invoices Service
    'http://localhost:8086', // Order History Service
    'http://localhost:8087', // ATP Service
  ],
  // External links
  baseOMSLink: 'https://indi-oms-eks.acc.indicloud.net/omt/app/',
  baseICMLink: 'https://webshop.acc.indicloud.net/INTERSHOP/web/WFS/org-Site/nl_NL/webshop/EUR/',
  baseIndiUrl: 'https://webshop.acc.indicloud.net/',
  baseFreshdeskUrl: 'https://indisandbox.freshdesk.com',
  freshdeskServiceUrl: 'https://freshdesk-support-service.acc.indicloud.net/',
  baseDLCSUrl: 'https://dlcs.acc.indicloud.net/',
  orderHistoryServiceUrl: 'http://localhost:8086/',
  // SCSN
  scsnCustomersUrl: 'http://localhost:8081/customers',
  // Customers
  shippingAddressesUrl: 'http://localhost:8082/shipping-addresses',
  indiCustomersUrl: 'http://localhost:8082/indi-customers',
  connectionStatusCheckUrl: 'http://localhost:8082/q/health',
  // Products
  productsServiceUrl: 'http://localhost:8083',
  // Orders
  returnsServiceUrl: 'http://localhost:8084/returns',
  returnFailuresServiceUrl: 'http://localhost:8084/returns/faileds',
  dispatchFailuresServiceUrl: 'http://localhost:8084/dispatches/faileds',
  mancosServiceUrl: 'http://localhost:8084/mancos',
  salesordersServiceUrl: 'http://localhost:8084/verkooporders',
  sosEmailServiceUrl: 'http://localhost:8084/sos',
  orderShipmentInfoServiceUrl: 'http://localhost:8084/order-shipment-info',
  // Invoices
  invoiceSearchServiceUrl: 'http://localhost:8085/invoices',
  paymentTermsCheckerServiceUrl: 'http://localhost:8085/payment-terms',
  // ATP (dev-mode atp-service runs on 8087; 8080-8086 are taken, see its application.properties)
  atpServiceUrl: 'http://localhost:8087/atp/portal',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
